import { render } from "./ViewOrdersReports.vue?vue&type=template&id=b9ce71fe&scoped=true"
import script from "./ViewOrdersReports.vue?vue&type=script&lang=js"
export * from "./ViewOrdersReports.vue?vue&type=script&lang=js"

import "./ViewOrdersReports.vue?vue&type=style&index=0&id=b9ce71fe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ce71fe"]])

export default __exports__